"use client";

import * as React from "react";
import type { Column } from "@tanstack/react-table";
import { Input } from "@/components/ui/input";
import { useDebouncedCallback } from "@/hooks/use-debounced-callback";

interface DebouncedFilterInputProps<TData> {
    column: Column<TData>;
    placeholder?: string;
    className?: string;
    type?: React.InputHTMLAttributes<HTMLInputElement>["type"];
    delay?: number;
}

export function DebouncedFilterInput<TData>({
    column,
    placeholder,
    className,
    type = "text",
    delay = 300,
}: DebouncedFilterInputProps<TData>) {
    const initial = (column.getFilterValue() as string) ?? "";
    const [value, setValue] = React.useState<string>(initial);

    // Sync local input when external filter value changes (e.g., reset)
    React.useEffect(() => {
        setValue((column.getFilterValue() as string) ?? "");
         
    }, [column.getFilterValue()]);

    const debouncedSet = useDebouncedCallback((next: string) => {
        column.setFilterValue(next);
    }, delay);

    const handleChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const next = e.target.value;
            setValue(next);
            debouncedSet(next);
        },
        [debouncedSet],
    );

    return (
        <Input
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            className={className}
        />
    );
}


